import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { AuthModalProvider } from './state/AuthModalContext';
import AuthModal from './components/AuthModal';

// --- NETTOYAGE AGRESSIF : On nettoie TOUT au chargement ---
async function purge() {
  if ('serviceWorker' in navigator) {
    const registrations = await navigator.serviceWorker.getRegistrations();
    for (const registration of registrations) {
      await registration.unregister();
      console.log('SW Purged');
    }
  }
}

purge().then(() => {
  const root = ReactDOM.createRoot(document.getElementById('root'));
  root.render(
    <React.StrictMode>
      <AuthModalProvider>
        <App />
        <AuthModal />
      </AuthModalProvider>
    </React.StrictMode>
  );
});

reportWebVitals();
